import { compose } from 'redux';
import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

import FormMultilineTextField from 'components/FormMultilineTextField';
import StylingToCSSLabelText from 'styling/hocs/StylingToCSS/StylingToCSSLabelText';
import StylingToCSSTextfield from 'styling/hocs/StylingToCSS/StylingToCSSTextfield';
import propTypeStyleLabel from 'styling/config/editorBlock/PropTypes/styleLabel';
import propTypeStyleTextfield from 'styling/config/editorBlock/PropTypes/styleTextfield';

import styles from './CommentsField.scss';

const CommentsField = ({
  commentsEnabled,
  commentsLabel,
  className,
  readOnly = false,
  disabled = false,
  meta = {},
  styleLabel,
  styleTextfield,
  ...rest
}) => {
  const label = <span style={styleLabel}>{commentsLabel}</span>;

  return commentsEnabled ? (
    <FormMultilineTextField
      {...rest}
      meta={meta}
      disabled={!readOnly && disabled}
      className={cx(className, { [styles.readOnly]: readOnly })}
      inputClassName={styles.textInput}
      labelClassName={styles.textLabel}
      disabledLabelClassName={styles.disabledTextLabel}
      label={label}
      style={styleTextfield}
    />
  ) : null;
};

CommentsField.propTypes = {
  commentsEnabled: PropTypes.bool,
  commentsLabel: PropTypes.string,
  className: PropTypes.string,
  meta: PropTypes.object,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  styleLabel: propTypeStyleLabel,
  styleTextfield: propTypeStyleTextfield,
};

export default compose(
  StylingToCSSLabelText,
  StylingToCSSTextfield,
)(CommentsField);
